import React, { useCallback, useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { auto, menu, sip } from '../translate'
import { useDispatch } from 'react-redux'
import { blockedCreateRequest } from '../store/actions/blocked'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import { greenTheme, inputStyles } from '../helpers/style'

const primaryColor = greenTheme.primary

function AddBlocked({ open, setOpen, edit = false }) {
  const [form, setForm] = useState({ phone: '', notes: '' })
  const location = useLocation()
  const query = qs.parse(location.search, { arrayFormat: 'comma' })
  const dispatch = useDispatch()
  const langIndex = +localStorage.getItem('atsLang') || 1

  const handleChange = useCallback((name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }))
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
    setForm({ phone: '', notes: '' })
  }, [setOpen])

  const handleAdd = useCallback(
    async (ev) => {
      ev?.preventDefault()
      await dispatch(blockedCreateRequest(10, query.page || 1, query.search || '', form))
      handleClose()
    },
    [dispatch, form, query.page, query.search, handleClose]
  )

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{menu.block[langIndex]}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          <TextField
            label={auto.phone[langIndex]}
            value={form.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            fullWidth
            required
            sx={inputStyles}
          />
          <TextField
            label={sip.note[langIndex]}
            value={form.notes}
            onChange={(e) => handleChange('notes', e.target.value)}
            fullWidth
            sx={inputStyles}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {langIndex === 2 ? 'Отмена' : langIndex === 3 ? 'Չեղարկել' : 'Cancel'}
        </Button>
        <Button onClick={handleAdd} variant="contained" sx={{ backgroundColor: primaryColor }}>
          {sip.add_btn[langIndex]}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddBlocked
